var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38281 20.5002H22.3828",
    stroke: "#2F405A",
    strokeWidth: 1.52856,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8917 7.76656C20.4449 7.20217 20.4449 6.35558 19.8917 5.79119L17.4023 3.25142C16.8491 2.68703 16.0193 2.68703 15.4662 3.25142L5.09375 13.8338V18.3489H9.51931L19.8917 7.76656ZM16.4342 4.23911L18.9236 6.77888L16.8491 8.89535L14.3598 6.35558L16.4342 4.23911ZM6.47674 16.938V14.3982L13.3917 7.34327L15.881 9.88304L8.96611 16.938H6.47674Z",
    fill: "#2F405A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.41c53624b4024def0aa0261d2ee2e9c5.svg";
export { ForwardRef as ReactComponent };